"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.months = exports.abbreviatedMonths = exports.isAfterFourPM = exports.getDateNYC = exports.renderDayLong = exports.renderDayShort = void 0;

var _index = require("../index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ HELPER FUNCTIONS ++++++++++ */


var renderDay = function renderDay(selectedDay, options) {
  // This is so cool! I don't mind "dating" JS anymore :D
  // Need to specify timezone in order to get correct date. Abstract shows library page should always show dates in EST, hence passing the Eastern time hardcoded here.
  // Fix for RangeError in firefox: Convert the date into UTC string first and then pass timezone you want. new Date('1-1-2019 EDT') works for chrome but not for firefox
  // Fix for safari: remove the .0 from date string we are getting from backend
  return new Intl.DateTimeFormat('en-US', options).format(new Date(Date.parse(selectedDay.replace(/-/g, "/").replace(/\.0/g, " "))));
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// Use this if you need dates in format "Jul 2, 2019"


var renderDayShort = function renderDayShort(selectedDay) {
  var options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  return renderDay(selectedDay, options);
}; // USe if you need dates in format "June 19, 2019, 11:58 AM EDT"


exports.renderDayShort = renderDayShort;

var renderDayLong = function renderDayLong(selectedDay) {
  var options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short'
  };
  return renderDay(selectedDay, options);
}; ////--=-=-=-=-= This utils purpose is to return true if it is after 4pm and false if it isnt -=-=-=-=-=-=/////


exports.renderDayLong = renderDayLong;

var getDateNYC = function getDateNYC() {
  var date = new Date();
  var nycLocale = date.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  });
  return new Date(nycLocale);
};

exports.getDateNYC = getDateNYC;

var isAfterFourPM = function isAfterFourPM() {
  var nycDate = getDateNYC();
  var time = nycDate.getHours();
  return time >= 16 || _index.environment !== 'PRODUCTION';
};

exports.isAfterFourPM = isAfterFourPM;
var abbreviatedMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
exports.abbreviatedMonths = abbreviatedMonths;
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
exports.months = months;